<template>
  <div style="position: relative">
    <v-banner
      v-if="canShowBanner"
      :bg-color="`${color}-lighten-1`"
      :color="color"
      :icon="icon"
      class="banner gx-2"
      lines="two"
      sticky
    >
      <v-banner-text>
        <div class="d-flex align-items-center h-full">
          {{ banner.text }}
        </div>
      </v-banner-text>
      <template #actions>
        <v-btn icon variant="text" class="ma-0 pa-0" @click="close">
          <v-icon color="secondary">n:close</v-icon>
        </v-btn>
      </template>
    </v-banner>
  </div>
</template>

<script lang="ts" setup>
import { ignoreRouteNames, useSystemBannersStore } from "~/store/systemBanners";

const store = useSystemBannersStore();
const { banner } = storeToRefs(store);
const { close } = store;
const $route = useRoute();

const canShowBanner = computed(() => {
  return !!banner.value && !ignoreRouteNames.includes($route.name as string);
});

const color = computed(() => {
  if (!banner.value) {
    return undefined;
  }

  switch (banner.value.type) {
    case "info":
      return "secondary";
    case "warning":
      return "orange";
    case "error":
      return "primary";
    default:
      return "green";
  }
});

const icon = computed(() => {
  if (!banner.value) {
    return undefined;
  }
  switch (banner.value.type) {
    case "info":
      return "n:info";
    case "warning":
      return "n:comment-alert";
    case "error":
      return "n:alert-outline";
    default:
      return undefined;
  }
});
</script>

<style lang="scss" scoped>
.banner {
  z-index: 300;
  position: absolute;

  :deep(.v-banner__prepend) {
    align-self: center;
  }

  :deep(.v-banner__content) {
    align-self: center;
  }

  :deep(.v-banner-actions) {
    align-self: center;
    margin-top: 0 !important;
  }
}
</style>
